import React, { useState, useEffect } from "react";

import {
  Col,
  Card,
  Row,
  Pagination,
  Nav,
  ListGroup,
} from "@themesberg/react-bootstrap";
import { formatDistanceToNow } from "date-fns";
import Loader from "../../components/Loader";
import axios from "axios";
import { getNotifications } from "../../app/api";
export default () => {
  const [notifications, setNotifications] = useState([]);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async (currentPage) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(getNotifications(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
        },
      });
      // console.log("notification", response.data);

      setNotifications(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false); // Hide loader after fetching data
    }
  };

  useEffect(() => {
    fetchNotifications(page);
  }, [page]);
  // Utility function to get relative time
  const getRelativeTime = (timestamp) => {
    const date = new Date(timestamp);
    return formatDistanceToNow(date, { addSuffix: true });
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
        <div className="d-block  mb-md-0">
          <h4 className="mb-0">Notifications</h4>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Row>
          <Col xs={12} xl={12} className="mb-4">
            {notifications.map((data) => (
              <ListGroup.Item
                key={`notification-${data.id}`}
                className="border-bottom border-light"
              >
                <Row className="align-items-center">
                  <Col className="col-auto">
                    {/* <Image src={data.image} className="user-avatar lg-avatar rounded-circle" /> */}
                  </Col>
                  <Col className="ps-0 ms--2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <p className=" mt-1 mb-0">{data.details}</p>
                      </div>
                      <div className="text-end">
                        <p className=" mt-1 mb-0">
                          {getRelativeTime(data.datetime)}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </Col>
          <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
            <Nav className="justify-content-center mb-4">
              <Pagination className="mb-2 mb-lg-0">
                <Pagination.Prev
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === page}
                    onClick={() => setPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() =>
                    setPage((prev) => Math.min(prev + 1, totalPages))
                  }
                />
              </Pagination>
            </Nav>
          </Card.Footer>
        </Row>
      )}
    </>
  );
};
